// Import Redux Toolkit's method for creating a store
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import mainReducer from "./MainReducer";
// Import the root reducer that combines all app reducers
import rootReducer from "./RootReducer";

// Create the Redux store using the root reducer
// configureStore sets up good default middleware and DevTools integration
const Store = configureStore({
  reducer: {
    rootReducer,
    mainReducer,
    auth: authReducer,
  },
});

// Export the store to be used throughout the app (e.g., with <Provider>)
export default Store;
